export const apiGatewayUrlParam = `https://api.${process.env.REACT_APP_DOMAIN}/service/`;
export const publicContentUrl = `https://public.content.${process.env.REACT_APP_DOMAIN}/`